<template>
  <div class="container">
    <div v-if="data.length" class="container_certificate">
      <div class="centent_certificate" v-for="item in data" :key="item.id">
        <div class="imgcontainer">
          <img :src="item.url" alt="图片加载失败" @click.stop="bigImage(item.url)" />
        </div>
      </div>
    </div>
    <div v-else class="null">抱歉,您暂时还没有获得证书噢~,要加油咯</div>
    <!-- 全屏图片浏览视图 -->
    <PreviewPhotos ref="shadowPhotos" />
  </div>
</template>

<script>
import { Utils } from "../utils";

import { types as CertificateTypes } from "@/store/modules/certificate";
import { mapState, mapActions } from "vuex";
//引入封装的图片放大组件
import PreviewPhotos from "./components/PreviewPhotos";

export default {
  name: "Certificate",
  components: {
    PreviewPhotos
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    //将vuex中获取到的数据映射到计算属性中并改名
    ...mapState({
      //获取到对象
      data: state => state.certificate.certificate.data,
      page: state => state.certificate.certificate.page,
      load_more: state => state.certificate.certificate.load_more,
      total_count: state => state.certificate.certificate.total_count
    })
  },
  methods: {
    ...mapActions({
      fetchcertificate: CertificateTypes.FETCH_CERTIFICATE_DETAIL
    }),
    ...Utils,
    //给图片放大组件传递url
    bigImage(url) {
      this.$refs.shadowPhotos.showShadowView([url]);
    },
    handleScroll(e) {
      let page = this.page;
      let load_more = this.load_more;

      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (scrollHeight <= height + scrollTop + 20) {
        if (load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.fetchcertificate({
            page: page + 1,
            certificate_id: that.$route.params.user
          });
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    }
  },
  
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    //页面挂载的时候获取证书
    // console.log(this.$route.params.user);
    if(this.$route.params.user){
      this.certificate_id = this.$route.params.user
    }
    this.fetchcertificate({
      page:1,
      certificate_id:this.certificate_id
    });
  }
};
</script>

<style lang="less" scoped>
.container_certificate {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 5px 100px;
  .imgcontainer {
    width: 240px;
    height: 349px;
    // background-color: #ff7b00 !important;
    margin: 25px 26px;
    padding-top: 2px;
    border-radius: 8px;
    img {
      width: 240px;
      height: 349px;
      border-radius: 8px;
      cursor: pointer;
    }
  }
}

.container {
  text-align: center;
  .null {
    color: red;
  }
}
</style>
